import { GetCurrentProductionHomeResponse, GetGeneralInformationHomeResponse } from "../../interfaces/services/get-home-services";
import { GetMessagesByProducerResponse } from "../../interfaces/services/get-messages-by-producer-service";
import { getError, getUserInfo } from "../../utils";
import CustomHttpClient from "../customHttpClient";


const customHttpClient = CustomHttpClient({ baseUrl: 'productores' });
const customHttpClientQuotation = CustomHttpClient({ baseUrl: 'productores/cotizacion' });

const HomeService = {
    async getCurrentWallet(): Promise<GetGeneralInformationHomeResponse> {
        const url = 'obtenerCarteraVigente';
        const params = {
          ...getUserInfo(),
        };
    
        try {
          const response = await customHttpClient.get(url, { params });
    
          return response.data;
        } catch (error) {
          throw new Error(getError(error));
        }
    },

    async getCurrentProduction(): Promise<GetCurrentProductionHomeResponse> {
        const url = 'obtenerProduccionVigente';
        const params = {
          ...getUserInfo(),
        };
    
        try {
          const response = await customHttpClient.get(url, { params });
    
          return response.data;
        } catch (error) {
          throw new Error(getError(error));
        }
    },

    async getWebQuotations(): Promise<GetGeneralInformationHomeResponse> {
        const url = 'obtenerCotizacionesWeb';
        const params = {
          ...getUserInfo(),
        };
    
        try {
          const response = await customHttpClient.get(url, { params });
    
          return response.data;
        } catch (error) {
          throw new Error(getError(error));
        }
    },

    async getCurrentPolicies(): Promise<GetGeneralInformationHomeResponse> {
        const url = 'obtenerPolizasVigente';
        const params = {
          ...getUserInfo(),
        };
    
        try {
          const response = await customHttpClientQuotation.get(url, { params });
    
          return response.data;
        } catch (error) {
          throw new Error(getError(error));
        }
    },

    async getClaims(): Promise<GetGeneralInformationHomeResponse> {
        const url = 'obtenerSiniestrosDenunciados';
        const params = {
          ...getUserInfo(),
        };
    
        try {
          const response = await customHttpClient.get(url, { params });
    
          return response.data;
        } catch (error) {
          throw new Error(getError(error));
        }
    },

    async getClaimsVsWallet(): Promise<GetGeneralInformationHomeResponse> {
        const url = 'obtenerSiniestrosVsCartera';
        const params = {
          ...getUserInfo(),
        };
    
        try {
          const response = await customHttpClient.get(url, { params });
    
          return response.data;
        } catch (error) {
          throw new Error(getError(error));
        }
    },
    
  async getUserNotifications(): Promise<GetMessagesByProducerResponse> {
    const url = 'mensajesPorProductor';
    const params = {
      ...getUserInfo(),
    };

    try {
      const response = await customHttpClient.get(url, { params });

      return response.data;
    } catch (error) {
      throw new Error(getError(error));
    }
  },

  async updateNotificationStatus(idMessage: string, action: string): Promise<GetMessagesByProducerResponse> {
    const url = 'cambiarEstadoDeMensaje';
    const body = {
      ...getUserInfo(),
      idMensaje: idMessage,
      accion: action
    };

    try {
      const response = await customHttpClient.post(url, body );

      return response.data;
    } catch (error) {
      throw new Error(getError(error));
    }
},
}

export default HomeService;